import { render } from "./Download.vue?vue&type=template&id=28559b7a"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=28559b7a&lang=scss"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__